import styled from "styled-components";

export const Container = styled.div`
	display: flex;
	font-size: 0.9rem;
`;
export const Label = styled.span`
	font-weight: bold;
	margin-right: 5px;
`;
export const Value = styled.div``;
